import { sleep } from "oc-commons/Commons";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";

export function ZaunCircleMenuItemAuffüllen({ zaunCircleMenu }) {
  const agt = APP.arrangement;
  const isEmpty = APP.arrangement?.selectedObjects[0]?.isEmpty;
  const contract = () => {
    return (
      (agt.selectedObjects.length == 1 &&
        agt.selectedObjects[0]?.isEmpty &&
        agt.selectedObjects[0].isBreiteKonfigurierbar) ||
      (agt.selectedObjects.length > 0 &&
        agt.selectedObjects.every((e) => !e.isEmpty) &&
        !agt.selectedObjects.some((e) => e.isPfosten))
    );
  };
  if (!contract()) {
    return null;
  }
  const label = I18N("Elemente aufrücken");
  return isEmpty ? (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={async (event) => {
        if (!contract()) {
          return null;
        }
        event.stopPropagation();
        zaunCircleMenu.current.implodeSelectCircle();
        await sleep(200);
        APP.arrangement.removeSelectedObjects();
        APP.logUserAction({ action: "elementeAufrücken" });
      }}
    >
      <div className="flex-row">
        <span>&nbsp;{label}</span>
      </div>
    </ZaunCircleMenuItem>
  ) : null;
}
